import "./video.scss";

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.embedded-video__overlay')
  const transcript = document.querySelector('.transcript__show')

  function displayVideo(video) {
    const image = video.parentNode;
    const player = image.parentNode.querySelector('.embedded-video__player');
    const iframe = player.querySelector("iframe")
    iframe.setAttribute('height', image.offsetHeight);
    //Autoplay works only on desktop, 
    iframe.setAttribute('src', iframe.getAttribute('src')+'?autoplay=1');
    //it's disabled on iOS & Android devices (for data usage reasons)
    image.style.display = 'none';
    player.style.display = 'block';
  }
  if (transcript) {
    let shown = false;

    transcript.addEventListener("click", (event) => {
      transcript.querySelector('p').innerHTML = shown ? 'Show transcript' : 'Hide transcript'
      shown = shown ? false : true;
      transcript.querySelector('.arrow').classList.toggle("rotate")
      transcript.querySelector('.transcript__show__button').classList.toggle('expanded')
      const transcriptText = document.querySelector('.transcript')
      transcriptText.classList.toggle("hidden")
    })
  }
  if (videos) {
    videos.forEach((video) => {
      video.addEventListener("click", (event) => {
        event.stopPropagation();
        displayVideo(video);
      });
      video.addEventListener("touchend", (event) => {
        event.stopPropagation();
        displayVideo(video);
      });
    });
  }

});